import React from "react";
import BaseLogo from "../../../../components/BaseLogo";
import "./style.scss";
import PropTypes from "prop-types";

export default function SectionHeader({ isHideBackgroundElems }) {
  SectionHeader.propTypes = {
    isHideBackgroundElems: PropTypes.bool,
  };
  return (
    <section
      className={`section-header ${
        isHideBackgroundElems && "section-header_less-padding"
      }`}
    >
      {!isHideBackgroundElems && (
        <BaseLogo
          className="section-header__logo"
          iconLogoStyle="section-header__logo__icn"
        />
      )}
    </section>
  );
}
